<template>
	<div class="input select" :class="{ 'input-error': errors[id] }">
		<label :for="id" v-if="name">{{ name }}</label>
		<v-select :multiple="multiSelect === true" v-model="selectedOption" :label="label || 'value'" :options="options" :clearable="clearable === true"></v-select>
		<span class="error-message">{{ errors[id] }}</span>
	</div>
</template>

<script>
	export default {
		data: () => {
			return {
				selectedOption: null
			}
		},
		props: ['id', 'name', 'optionKey', 'label' ,'form', 'errors', 'options', 'clearable', 'multiSelect'],
		mounted() {
			this.selectOptionFromForm()
		},
		watch: {
			form(form) {
				this.selectOptionFromForm()
			},
			selectedOption(selectedOption) {
				if(selectedOption && this.multiSelect) {
					this.form[this.id] = selectedOption.map(option => option[this.optionKey || 'key'])
				}
				else if(selectedOption) {
					this.form[this.id] = selectedOption[this.optionKey || 'key']
				} else {
					this.form[this.id] = ''
				}
				this.errors[this.id] = ''
			}
		},
		methods: {
			selectOptionFromForm() {
				if(this.form[this.id] || this.form[this.id] == 0) {
					if(Array.isArray(this.form[this.id])) {
						this.selectedOption = []
					}
					this.options.forEach(option => {
						if(Array.isArray(this.form[this.id]) && this.form[this.id].includes(option[this.optionKey || 'key'])) {
							this.selectedOption.push(option)
						} else if(option[this.optionKey || 'key'] == this.form[this.id]) {
							this.selectedOption = option
							return
						}
					})
				} else {
					this.selectedOption = null
				}
				this.errors[this.id] = ''
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Form/InputSelect.vue